// Load SVGsimport * as Sentry from '@sentry/browser';
import staticUrl from './static-path';

export default function icons() {
  const baseURL = `${staticUrl()}rangers/images/svg/master.svg`;
  const request = new XMLHttpRequest();
  request.open('GET', baseURL, true);

  request.onload = function() {
    if (request.status >= 200 && request.status < 400) {
      const div = document.createElement('div');
      div.innerHTML = request.response;
      document.body.insertBefore(div, document.body.childNodes[0]);
    }
  };

  request.send();

  return this;
}



// WEBPACK FOOTER //
// ./library/js/modules/icons.js